// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"G_vq h_jq h_fq h_ft h_fF h_dM h_h","menuItemSub":"G_vr h_dT h_fq h_fF","menuMainLink":"G_vs h_jr h_hl","menuLink":"G_vt h_jr h_hl","Link":"G_r9 v_r9 v_rn v_rJ"};